module.exports = __webpack_public_path__ + "static/img/IMG_20170720_003951.74ba19b9.jpg";